export default {
  'navbar.home': 'Accueil',
  'navbar.explore': 'Explorer',
  'navbar.favorites': 'Favoris',
  'navbar.messages': 'Messages',
  'navbar.login': 'Connexion',
  'navbar.register': 'Inscription',
  'navbar.about': 'À propos',
  'navbar.how_it_works': 'Comment ça marche',
  'navbar.pricing': 'Tarifs',
  'navbar.blog': 'Blog',
  'navbar.support': 'Support',
  'navbar.dashboard': 'Tableau de bord',
  'navbar.admin': 'Administration',
  'navbar.logout': 'Déconnexion',
  'navbar.brand': 'Pink Paradise',
  'navbar.toggle_theme': 'Changer le thème',
  'navbar.change_language': 'Changer la langue',
  'navigation.messages': 'Messages',
  'navbar.open_menu': 'Ouvrir le menu',
  'navbar.menu': 'Menu',
  'navbar.sugar_dating': 'Sugar Dating'
};
